
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Button, Form, Dropdown } from "react-bootstrap";
import DataTable, { createTheme } from "react-data-table-component";
import { FaStar } from "react-icons/fa";
import { Link } from "react-router-dom";
import config from "../../../../config";
import config1 from "../../../../coreFIles/config";
import Header from "../../../commanComponents/usernavbar";
import { RiDeleteBin6Line } from "react-icons/ri";
import CustomMaterialMenu from "./customMaterialMenu";
import "../../css/createcheque.css";

import ListMenuButton from "./listMenu";
import UserNameAndTab from "./UserNameAndTab";

const Chartofaccount = () => {
  createTheme('solarized', {
    text: {
      primary: '#000',
      secondary: '#2aa198',
    },
    background: {
      default: '',
    },
    context: {
      background: '#cb4b16',
      text: '#FFFFFF',
    },
    divider: {
      default: '#EBEBEB',
    },
    action: {
      button: '#E46422',
      hover: 'rgba(0,0,0,.08)',
      disabled: 'rgba(0,0,0,.12)',
    },
  }, 'dark');

  const customStyles = {
    rows: {
      style: {
        minHeight: '70px', // override the row height

      },
    },
    headCells: {

      style: {
        minHeight: '60px',
        paddingLeft: '20px', // override the cell padding for head cells
        paddingRight: '20px',
        background: '#FFF8F4',

      },
    },
    cells: {
      style: {
        paddingLeft: '20px', // override the cell padding for data cells
        paddingRight: '20px',
      },
    },
  };
  const navigate = useNavigate();


  const handleDelete = (id) => {
    const updatedData = data.filter(item => item.id !== id);
    setData(updatedData);
  };

  const columns = [
    {
      name: "#",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "10%"
    },
    {
      name: 'Name',
      selector: row => row.Name,
      width: "19%"
    },
    {
      name: 'Account Type',
      selector: row => row.AccountName,
      width: "19%"
    },
    {
      name: 'Detail Type',
      selector: row => row.DetailType,
      sortable: true,
      width: "16%"
    },
    {
      name: 'Balance',
      selector: row => row.Balance,
      width: "16%"
    },

    {
      name: "Action",
      cell: (row) => <CustomMaterialMenu size="small" row={row} />,
      allowOverflow: true,
      style: {
        paddingLeft: "10px"
      }
    },


  ];


  const [data, setData] = useState([
    {
      id: 1,
      Name: 'Loss & Disposable Of assests',
      AccountName: 'Loss & Disposable Of assests',
      DetailType: 'Loss',
      Balance: 'G$52.30'

    },
    {
      id: 2,
      Name: 'Loss & Disposable Of assests',
      AccountName: 'Loss & Disposable Of assests',
      DetailType: 'Loss',
      Balance: 'G$52.30'

    },
    {
      id: 3,
      Name: 'Loss & Disposable Of assests',
      AccountName: 'Loss & Disposable Of assests',
      DetailType: 'Loss',
      Balance: 'G$52.30'

    },
    {
      id: 4,
      Name: 'Loss & Disposable Of assests',
      AccountName: 'Loss & Disposable Of assests',
      DetailType: 'Loss',
      Balance: 'G$52.30'

    },
    {
      id: 5,
      Name: 'Loss & Disposable Of assests',
      AccountName: 'Loss & Disposable Of assests',
      DetailType: 'Loss',
      Balance: 'G$52.30'

    },
    {
      id: 6,
      Name: 'Loss & Disposable Of assests',
      AccountName: 'Loss & Disposable Of assests',
      DetailType: 'Loss',
      Balance: 'G$52.30'

    },
    {
      id: 7,
      Name: 'Loss & Disposable Of assests',
      AccountName: 'Loss & Disposable Of assests',
      DetailType: 'Loss',
      Balance: 'G$52.30'

    },

  ]);


  useEffect(() => {
    // Add the class to the body tag
    document.body.classList.add("staffbody");

    // Cleanup function to remove the class when the component is unmounted
    return () => {
      document.body.classList.remove("staffbody");
    };
  }, []);

  const navigateRoute = () => {
    setTimeout(() => {
      navigate(`${config.baseurl}${config.loginurl}`, { state: "prop" });
      window.location.reload();
    });
  };


  return (
    <div className="staffdashboard bg-pink">
      <Header />
      <section className="listing pt-5 pb-5 overflow-hidden vh-80">
        <Container>
          <UserNameAndTab />
          <div className="listMenuButton">
            <Col xl={12} lg={12} className="mb-3">
              <Card className="border-0 tablistfinance">
                <Card.Body>
                  <ListMenuButton />
                </Card.Body>
              </Card>
            </Col>
          </div>

          <div className="">
            <Col lg={12} className="mb-3">
              <Card className="border-0 bg-white p-3">
                <Card.Header className="mb-3 pb-3">
                  <div className="d-sm-flex justify-content-between align-items-center">
                    <div className="mb-2"><h4 className="mb-0 fw-bolder">Chart Of Account</h4></div>
                    <div className="text-end mb-sm-3">

                      <div>

                        <div className="d-inline-block">
                          <Button
                            variant="default"
                            className="me-4 p-0 h-auto"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                              <path d="M17.0703 5.03906H16.5234V2.92969C16.5234 1.31426 15.2092 0 13.5938 0H6.40625C4.79082 0 3.47656 1.31426 3.47656 2.92969V5.03906H2.92969C1.31426 5.03906 0 6.35332 0 7.96875V12.6562C0 14.2717 1.31426 15.5859 2.92969 15.5859H3.47656V18.2422C3.47656 19.2114 4.26512 20 5.23438 20H14.7656C15.7349 20 16.5234 19.2114 16.5234 18.2422V15.5859H17.0703C18.6857 15.5859 20 14.2717 20 12.6562V7.96875C20 6.35332 18.6857 5.03906 17.0703 5.03906ZM4.64844 2.92969C4.64844 1.96043 5.43699 1.17188 6.40625 1.17188H13.5938C14.563 1.17188 15.3516 1.96043 15.3516 2.92969V5.03906H4.64844V2.92969ZM15.3516 18.2422C15.3516 18.5653 15.0887 18.8281 14.7656 18.8281H5.23438C4.91129 18.8281 4.64844 18.5653 4.64844 18.2422V12.4609H15.3516V18.2422ZM18.8281 12.6562C18.8281 13.6255 18.0396 14.4141 17.0703 14.4141H16.5234V12.4609H16.875C17.1986 12.4609 17.4609 12.1986 17.4609 11.875C17.4609 11.5514 17.1986 11.2891 16.875 11.2891H3.125C2.80141 11.2891 2.53906 11.5514 2.53906 11.875C2.53906 12.1986 2.80141 12.4609 3.125 12.4609H3.47656V14.4141H2.92969C1.96043 14.4141 1.17188 13.6255 1.17188 12.6562V7.96875C1.17188 6.99949 1.96043 6.21094 2.92969 6.21094H17.0703C18.0396 6.21094 18.8281 6.99949 18.8281 7.96875V12.6562Z" fill="black" />
                              <path d="M11.5625 13.7891H8.4375C8.11391 13.7891 7.85156 14.0514 7.85156 14.375C7.85156 14.6986 8.11391 14.9609 8.4375 14.9609H11.5625C11.8861 14.9609 12.1484 14.6986 12.1484 14.375C12.1484 14.0514 11.8861 13.7891 11.5625 13.7891Z" fill="black" />
                              <path d="M11.5625 16.2891H8.4375C8.11391 16.2891 7.85156 16.5514 7.85156 16.875C7.85156 17.1986 8.11391 17.4609 8.4375 17.4609H11.5625C11.8861 17.4609 12.1484 17.1986 12.1484 16.875C12.1484 16.5514 11.8861 16.2891 11.5625 16.2891Z" fill="black" />
                              <path d="M5 7.53906H3.125C2.80141 7.53906 2.53906 7.80141 2.53906 8.125C2.53906 8.44859 2.80141 8.71094 3.125 8.71094H5C5.32359 8.71094 5.58594 8.44859 5.58594 8.125C5.58594 7.80141 5.32359 7.53906 5 7.53906Z" fill="black" />
                            </svg>
                          </Button>
                        </div>

                        <div className="d-inline-block">
                          <Button
                            variant="default"
                            className="me-4 p-0 h-auto "
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                              <path d="M19.4111 11.5896L18.5527 10.9047C17.9646 10.4355 17.9657 9.56352 18.5527 9.09527L19.4111 8.41035C20.0219 7.92289 20.1782 7.08703 19.7826 6.42277L18.0876 3.57723C17.6919 2.91301 16.8667 2.62629 16.1259 2.89527L15.0847 3.27336C14.3715 3.53227 13.5929 3.09559 13.4679 2.36863L13.2851 1.30559C13.1551 0.549102 12.4863 0 11.695 0H8.30503C7.5137 0 6.84493 0.549102 6.71487 1.30562L6.53206 2.36863C6.40685 3.09687 5.62716 3.53184 4.91531 3.2734L3.87411 2.89527C3.13324 2.62629 2.30817 2.91305 1.91245 3.57723L0.217469 6.42273C-0.178176 7.08691 -0.0219654 7.92281 0.588972 8.41031L1.44736 9.09523C2.03545 9.56445 2.03428 10.4364 1.44736 10.9047L0.588932 11.5896C-0.0219653 12.0771 -0.178216 12.913 0.217428 13.5772L1.91245 16.4227C2.30813 17.0869 3.13304 17.3737 3.87411 17.1047L4.91527 16.7266C5.62857 16.4676 6.40705 16.9046 6.53202 17.6313L6.71483 18.6943C6.84493 19.4509 7.5137 20 8.30499 20H11.695C12.4863 20 13.155 19.4509 13.2851 18.6944L13.4679 17.6314C13.5931 16.9034 14.3727 16.4681 15.0847 16.7267L16.1259 17.1047C16.8669 17.3738 17.6919 17.087 18.0876 16.4228L19.7826 13.5772C20.1782 12.913 20.0219 12.0771 19.4111 11.5896ZM16.6915 15.6415L15.6503 15.2634C13.9858 14.6591 12.1694 15.6787 11.8778 17.3745L11.695 18.4375H8.30503L8.12222 17.3745C7.83007 15.6754 6.01096 14.6603 4.34975 15.2634L3.30855 15.6415L1.61357 12.796L2.47196 12.1111C3.8442 11.0161 3.84134 8.9816 2.47196 7.88895L1.61357 7.20402L3.30859 4.35848L4.34975 4.73656C6.01422 5.34086 7.83063 4.32133 8.12222 2.62551L8.30499 1.5625H11.695L11.8778 2.62551C12.1699 4.3248 13.9891 5.33961 15.6502 4.73656L16.6914 4.35848L18.3868 7.20363C18.3868 7.20363 18.3867 7.20375 18.3864 7.20398L17.528 7.88891C16.1558 8.98375 16.1586 11.0183 17.528 12.111L18.3864 12.7959L16.6915 15.6415ZM10 6.14582C7.80738 6.14582 6.02353 7.8748 6.02353 10C6.02353 12.1252 7.80738 13.8542 10 13.8542C12.1926 13.8542 13.9765 12.1252 13.9765 10C13.9765 7.8748 12.1926 6.14582 10 6.14582ZM10 12.2917C8.69628 12.2917 7.63561 11.2636 7.63561 10C7.63561 8.73637 8.69628 7.70832 10 7.70832C11.3037 7.70832 12.3644 8.73637 12.3644 10C12.3644 11.2636 11.3037 12.2917 10 12.2917Z" fill="black" />
                            </svg>
                          </Button>
                        </div>
                        <div className="d-inline-block">
                          <Button
                            variant="blue"
                            className="p-0  px-5  rounded-5 text-white"
                          >
                            New
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>

                </Card.Header>
                <Card.Body className="p-0">
                  <div className="">
                    <Row>
                      <Col lg={12}>
                        <Row className="mt-2 align-items-end">

                          <Col lg={3} className="mb-4">
                            <Form.Label>All Transaction</Form.Label>
                            <div className="position-relative">
                              <Form.Control
                                type="text"
                                placeholder="Search..."
                                as="select"
                              >
                                <option value={`1`}>123456</option>
                                <option value={`2`}>123456</option>
                                <option value={`3`}>123456</option>
                              </Form.Control>
                              <span className="text-light-grey inner-field small"></span>
                            </div>
                          </Col>

                          <Col lg={3} className="mb-4">


                            <div className="position-relative">

                              <Form.Control
                                type="date"
                                placeholder="Date"
                                aria-label="firstName"
                                name="Date"
                              />
                              <span className="text-light-grey inner-field small">From</span>
                            </div>
                          </Col>
                          <Col lg={3} className="mb-4">

                            <div className="position-relative">

                              <Form.Control
                                type="date"
                                placeholder="Date"
                                aria-label="firstName"
                                name="Date"
                              />
                              <span className="text-light-grey inner-field small">To</span>
                            </div>
                          </Col>
                          <Col lg={3}>

                          </Col>
                          <Col lg={12}>
                            <hr className="mb-4 mt-0" style={{ color: "#EBEBEB", opacity: "1" }} />
                          </Col>

                        </Row>
                        <div className="">
                          <Row className="">
                            <Col lg={12} xs={12}>
                              <div className="mb-4">
                                <DataTable
                                  columns={columns}
                                  data={data}
                                  customStyles={customStyles}
                                  theme="solarized"
                                  selectableRows

                                />
                              </div>
                            </Col>

                          </Row>

                        </div>
                      </Col>

                    </Row>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </div>




        </Container>
      </section>
    </div >
  );
};

export default Chartofaccount;
